var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":"#"},on:{"click":_vm.prevDate}},[_vm._v("«")]),_vm._v(" "+_vm._s(_vm.currentMonth)+" ("+_vm._s(_vm.currentYear)+") "),_c('a',{attrs:{"href":"#"},on:{"click":_vm.nextDate}},[_vm._v("»")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a9795a7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-components/input-month-selector.vue
// module id = 1562
// module chunks = 0